import React, { ComponentType, useContext } from "react";
import { MenuRouteContext } from "app/app-context";
import _ from "lodash";
import { FORBIDENT_ROUTE } from "./route-consts";
import { Redirect, Route } from "react-router-dom";
import { RedirectProps, RouteProps } from "react-router";

type BaseRouteProps = Omit<RouteProps, "component" | "render" | "children">;

interface ProtectedRouteProps extends BaseRouteProps {
  component: ComponentType<any>;
  auth: boolean;
}

const RouteComponent = (Route as unknown) as ComponentType<RouteProps>;
const RedirectComponent = (Redirect as unknown) as ComponentType<RedirectProps>;

export function ProtectedRoute({
  component: Component,
  auth,
  ...rest
}: ProtectedRouteProps) {
  return (
    <RouteComponent
      {...rest}
      render={(props) =>
        auth === true ? (
          <Component {...props} />
        ) : (
          <RedirectComponent to={FORBIDENT_ROUTE} />
        )
      }
    />
  );
}

export function useCheckAuthorized() {
  const mapper = useContext<Record<string, number>>(MenuRouteContext);
  const auth = React.useCallback(
    (path: string) => {
      if (!_.isEmpty(mapper)) {
        if (mapper.hasOwnProperty("hasAnyPermission")) {
          return true;
        }
        if (!mapper.hasOwnProperty(path)) {
          return false;
        }
      }
      return true;
    },
    [mapper]
  );

  return {
    auth,
  };
}
